export default "__VITE_ASSET__282a40db__"